module.exports = {"510116001":"东升街道办","510116002":"西航港街道办","510116003":"华阳镇街道办","510116004":"中和街道办","510116005":"九江街道","510116006":"黄甲街道","510116007":"公兴街道","510116008":"协和街道","510116101":"太平镇","510116102":"永兴镇","510116106":"籍田镇","510116107":"正兴镇","510116108":"彭镇","510116109":"大林镇","510116110":"煎茶镇","510116111":"黄龙溪镇","510116112":"永安镇","510116115":"黄水镇","510116116":"金桥镇","510116119":"胜利镇","510116120":"新兴镇","510116121":"兴隆镇","510116122":"万安镇","510116123":"白沙镇","510116124":"三星镇","510116125":"合江镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510116.json
// module id = 2262
// module chunks = 0